import { createGlobalStyle } from "styled-components";
import colors from "./colors.js";
import mediaQuery from "./mediaQuery.js";
const GlobalStyle = createGlobalStyle` main {}


* {
	margin: 0;
	padding: 0;
	font-family: "Public Sans Variable", system-ui, sans-serif;
	font-display: swap;
	font-weight: 300;
	color: ${colors.neutral100};
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	border: none;
    box-sizing: border-box;
	@media (min-width: 1440px) {
	}
}

div[data-placeholder-image] {
	background-color: transparent !important;
}


html {
	width: 100%;
	font-size: 62.5%;
	@media (min-width: 1730px) {
		font-size: 0.578vw;
		font-size: clamp(62.5%, .578vw, 75%);
	}
}

body {
	width: 100vw;
	font-size: 1.4rem;
	background-color: ${colors.neutral100};
}



h1,
h2,
h3,
h4,
h5,
h6 {

	font-family:  "utile-display", sans-serif;
	font-weight: 400;
	font-style: normal;
}

strong {}

button {
	border: none;
	margin: 0;
	padding: 0;
	width: auto;
	overflow: visible;
	background: transparent;
	color: inherit;
	font: inherit;
	line-height: normal;
	-webkit-font-smoothing: inherit;
	-moz-osx-font-smoothing: inherit;
	-webkit-appearance: none;


}


::selection {
	background-color: ${colors.white};
	color: ${colors.dark};
}

::-moz-selection {
	background-color: ${colors.white}95;
	color: black;
}

`;

export default GlobalStyle;
